import React from 'react'
import Logo from '../../../images/icons/hi-marley_logo.svg'

const MarleyIcon = () => (
  <Logo width={104} height={24} />
)

export default MarleyIcon
